module.exports = __webpack_public_path__ + "img/Methamphetamine (MET).cb167506.png";